<template>
    <div class="page-support">
        <!--banner-->
        <div class="banner">
            <div class="container">
                <h2 class="timeline">优秀作者</h2>
            </div>
        </div>
        <!--banner-->
        <!--content-->
        <div class="container">
            <div class="single author">
                <div class=" single-grid">

                    <div class="tit">前言</div>

                    <p>{{settingList.author_text1}}</p>
                    <p>{{settingList.author_text2}}</p>
                    <p>{{settingList.author_text3}}</p>
                    <p>{{settingList.author_text4}}</p>
                    <p>{{settingList.author_text5}}</p>
                    <p>{{settingList.author_text6}}</p>
                    <div class="tit">投稿排行榜</div>
                    <p>{{settingList.author_tip}}</p>
                    <br>
                    <table class="my-table">
                        <tr>
                            <th width="100">排名</th>
                            <th>名称</th>
                            <th>游戏数量</th>
                            <th width="200">联系方式</th>
                        <tr v-for="(s, index) in gameData" :key="index">
                            <td width="100">{{s.index}}</td>
                            <td><a :href="'/#/s='+s.author" :title="'点击查看 @' + s.author + ' 投稿 / 汉化的所有游戏'" target="_blank">{{s.author}}</a></td>
                            <td><a :href="'/#/s='+s.author" :title="'点击查看 @' + s.author + ' 投稿 / 汉化的所有游戏'" target="_blank">{{s.count}}</a></td>
                            <td width="200">{{s.author_qq ? s.author_qq : '暂无'}}</td>
                        </tr>
                        <!-- <tr>
                            <td colspan="2">总计</td>
                            <td colspan="2">{{total2.toFixed(2)}} 元</td>
                        </tr> -->

                    </table>

          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 50, 100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
                </div>

            </div>
        </div>

        <!--//content-->
        <!--//about-->
        <!--联系方式-->
        <div class="contact">
            <div class="container">
                <h3>投稿方式</h3>
                <div class="address">
                    <div class=" address-more">
                        <div class="col-md-4 address-grid " v-for="(item, index) in activeContactList" :key="index">
                            <i :class='"glyphicon " + item.icon'></i>
                            <div class="address1">
                                <p>{{item.title}}</p>
                                <p v-if="item.link"><a :href="item.link" target="_blank" :title="item.tip">{{item.button}}</a></p>
                                <p v-if="!item.link"><a :title="item.tip">{{item.button}}</a></p>
                            </div>
                            <div class="clearfix"> </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix"> </div>

            </div>
        </div>
        <!--联系方式-->
    </div>
</template>
<script>
export default {
  name: 'Author',
  components: {
  },
  data() {
    return {
      total: 0,
      currentPage: 1,
      pagesize: 20,
      gameList: [],
      contactList: [],
      settingList: [],
      total2: 0
    }
  },
  created() {
    this.getSetting()
    this.getContact()
  },
  mounted() {},
  computed: {
    gameData() {
      return this.gameList.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this.pagesize)
    },
    activeContactList() {
      return this.contactList.filter(item => item.status === 1)
    }
  },
  methods: {
    getData() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/games.json' + '?' + timeStamp).then(game => {
        localStorage.setItem('gameList', JSON.stringify(game.data))
        const activeGames = game.data.filter(g => g.status !== 0 && g.author)
        const authorMap = {}
        activeGames.forEach(g => {
          const authors = Array.isArray(g.author) ? g.author : [g.author]
          const qqs = Array.isArray(g.author_qq) ? g.author_qq : [g.author_qq || '']
          authors.forEach((author, i) => {
            if (!authorMap[author]) {
              authorMap[author] = { count: 0, author_qq: qqs[i] || '' }
            }
            authorMap[author].count++
          })
        })
        this.gameList = Object.entries(authorMap).map(([author, data]) => ({ author, ...data })).sort((a, b) => b.count - a.count).map((item, index) => ({ ...item, index: index + 1 }))
        this.total = this.gameList.length
        this.total2 = activeGames.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
      },
      game => {
        console.log('error')
      }
      )
    },
    getStaticData() {
      var gameArr = JSON.parse(localStorage.getItem('gameList'))
      if(gameArr){
        const activeGames = JSON.parse(localStorage.getItem('gameList')).filter(g => g.status !== 0 && g.author)
        const authorMap = {}
        activeGames.forEach(g => {
          const authors = Array.isArray(g.author) ? g.author : [g.author]
          const qqs = Array.isArray(g.author_qq) ? g.author_qq : [g.author_qq || '']
          authors.forEach((author, i) => {
            if (!authorMap[author]) {
              authorMap[author] = { count: 0, author_qq: qqs[i] || '' }
            }
            authorMap[author].count++
          })
        })
        this.gameList = Object.entries(authorMap).map(([author, data]) => ({ author, ...data })).sort((a, b) => b.count - a.count).map((item, index) => ({ ...item, index: index + 1 }))
        this.total = this.gameList.length
        this.total2 = activeGames.reduce((sum, item) => sum + (Number(item.amount) || 0), 0)
      }else{
        this.getData()
      }
    },
    getContact() {
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/contact.json' + '?' + timeStamp).then(res => {
        this.contactList = res.data
      },
      res => {
        console.log('error')
      }
      )
    },
    getSetting() {
      const timeStamp = new Date().getTime()
      // 获取网站配置，存入本地储存
      this.$http.get('static/data/setting.json' + '?' + timeStamp).then(game => {
        this.settingList = game.data[0]
        // 如果本地有记录，对比配置版本号是否一致
        if(localStorage.getItem('settingList') && (game.data[0].version === JSON.parse(localStorage.getItem('settingList'))[0].version)){
          // 读取本地json
          this.getStaticData()
        } else {
          // 读取远程json
          this.getData()
          // 覆盖本地版本号
          localStorage.setItem('settingList', JSON.stringify(game.data))
        }
      })
    },
    open() {
      $('.hide_box').fadeIn()
      $('.shang_box').fadeIn()
    },
    goSearch(keyword) {
      this.$router.push({ path: '/s=' + keyword })
    },
    handleSizeChange(size) {
      this.pagesize = size
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
